import moment from "moment";
export default {
  props: {
    conteggio: Object,
  },
  data() {
    return {
      dialog_elimina: false,
      ordine: null,
      loading: true,
      loading_elimina: false,
      loading_invia: false,
      loading_archivia: false,
    };
  },
  mounted() {
    if (!this.conteggio.id_ordine) {
      this.loading = false;
      return;
    }
    this.loading = true;
    let ord = this.$store.getters.get_ordine_by_id(this.conteggio.id_ordine);
    if (!ord) {
      this.$store
        .dispatch("fetch_ordine_by_id", this.conteggio.id_ordine)
        .then((res) => {
          this.ordine = res;
          this.loading = false;
        });
    } else {
      this.ordine = ord;
      this.loading = false;
    }
  },
  computed: {
    cliente() {
      return this.$store.getters.get_cliente_by_iva(this.conteggio.cliente);
    },
    data_estesa() {
      return moment.unix(this.conteggio.ts).format("DD/MM/YYYY HH:mm");
    },
    data_breve() {
      return moment.unix(this.conteggio.ts).format("DD/MM");
    },
    tot_conteggio() {
      let conteggio = this.conteggio;
      if (this.conteggio.prodotti.length == 0) {
        return 0;
      }
      let listino = null;
      if (this.cliente.listino == 1) {
        listino = 1;
      } else if (this.cliente.listino == 2) {
        listino = 2;
      } else {
        listino = 3;
      }
      return conteggio.prodotti
        .map((prodotto) => {
          let prod = this.$store.getters.get_prodotto_by_id(
            prodotto.id_prodotto
          );
          if (prodotto.prezzo_contato) {
            return (
              prodotto.qta *
              (prodotto.a_vaso
                ? prodotto.prezzo_contato / prod.unita
                : prodotto.prezzo_contato)
            );
          }
          if (listino == 1) {
            return parseFloat(prod.prezzo1) * prodotto.qta;
          } else if (listino == 2) {
            return parseFloat(prod.prezzo2) * prodotto.qta;
          } else {
            return parseFloat(prod.prezzo3) * prodotto.qta;
          }
        })
        .reduce((sum, tot) => sum + tot, 0);
    },
    tot_iva_conteggio() {
      let conteggio = this.conteggio;
      if (this.conteggio.prodotti.length == 0) {
        return 0;
      }
      let listino = null;
      if (this.cliente.listino == 1) {
        listino = 1;
      } else if (this.cliente.listino == 2) {
        listino = 2;
      } else {
        listino = 3;
      }
      return conteggio.prodotti
        .map((prodotto) => {
          let prod = this.$store.getters.get_prodotto_by_id(
            prodotto.id_prodotto
          );
          if (prodotto.prezzo_contato) {
            return (
              prodotto.qta *
              (prodotto.a_vaso
                ? prodotto.prezzo_contato / prod.unita
                : prodotto.prezzo_contato) *
              (prod.iva / 100)
            );
          }
          if (listino == 1) {
            return parseFloat(prod.prezzo1) * prodotto.qta;
          } else if (listino == 2) {
            return parseFloat(prod.prezzo2) * prodotto.qta;
          } else {
            return parseFloat(prod.prezzo3) * prodotto.qta;
          }
        })
        .reduce((sum, tot) => sum + tot, 0);
    },
    tot_ordine() {
      if (!this.conteggio.id_ordine) {
        return 0;
      }
      return this.ordine.articoli
        .filter((art) => !art.eliminato)
        .map((prodotto) => {
          return prodotto.colori
            .map((col) => {
              return (
                (col.qta_admin ? col.qta_admin : col.numero) * prodotto.prezzo
              );
            })
            .reduce((sum, tot) => tot + sum, 0);
        })
        .reduce((sum, tot) => tot + sum, 0);
    },
    tot_trasporto() {
      if(!this.conteggio.trasporto){
        return 0;
      }
      let trasporto = this.$store.getters.get_trasporto;
      if (this.tot_conteggio > trasporto.soglia) {
        return 0;
      }
      let prezzo_trasporto = 0;
      switch (this.cliente.listino) {
        case "1":
          prezzo_trasporto = trasporto.prezzo_listino_1;
          break;
        case "2":
          prezzo_trasporto = trasporto.prezzo_listino_2;
          break;
        case "3":
          prezzo_trasporto = trasporto.prezzo_listino_3;
          break;
      }
      return prezzo_trasporto;
    },
    tot_iva_trasporto() {
      return this.tot_trasporto * 0.1;
    },
    discrepanza() {
      return this.tot_conteggio - this.tot_ordine;
    },
    creatore() {
      let user = this.$store.getters.get_admins_by_iva(
        this.conteggio.creato_da
      );
      return user ? user.nome : "Utente non trovato";
    },
  },
  methods: {
    elimina_conteggio() {
      this.loading_elimina = true;
      this.$store
        .dispatch("elimina_conteggio", this.conteggio.id)
        .finally(() => {
          this.loading_elimina = false;
        });
    },
    spedisci_conteggio() {
      this.loading_invia = true;
      this.$store
        .dispatch("invia_csv", this.conteggio.id)
        .then(() => {
          this.$emit("invio_ok");
        })
        .catch(() => {
          this.$emit("invio_fail");
        })
        .finally(() => {
          this.loading_invia = false;
        });
    },
    archivia_conteggio() {
      this.loading_archivia = true;
      this.$store
        .dispatch("archivia_conteggio", this.conteggio.id)
        .finally(() => {
          this.loading_archivia = false;
        });
    },
  },
};
